import React from 'react';
import './ProcessFlow.css';

const STEPS = [
  { icon: '💵', label: 'Funding'      },
  { icon: '🛒', label: 'Raw Purchase' },
  { icon: '🏢', label: 'To Organisers'},
  { icon: '👨‍🌾', label: 'To Farmers'  },
  { icon: '🌱', label: 'Cultivation'  },
  { icon: '📦', label: 'Collection'   },
  { icon: '🏭', label: 'Processing'   },
  { icon: '✅', label: 'Delivery'     },
];

/**
 * ProcessFlow – horizontal lifecycle diagram
 * @param {number} activeUpTo - index of last active step (0-based)
 */
export default function ProcessFlow({ activeUpTo = 4 }) {
  return (
    <div className="process-flow">
      {STEPS.map((s, i) => (
        <React.Fragment key={i}>
          <div className={`process-flow__node ${i <= activeUpTo ? 'process-flow__node--active' : ''}`}>
            <div className="process-flow__icon">{s.icon}</div>
            <div className="process-flow__label">{s.label}</div>
          </div>
          {i < STEPS.length - 1 && <div className="process-flow__arrow">→</div>}
        </React.Fragment>
      ))}
    </div>
  );
}
